module.exports = __webpack_public_path__ + "img/jlkf.07f184f2.png";